<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">退会</div>
      </md-card-header>

      <md-card-content v-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-if="terminated !== null">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <!--退会していない時-->
          <md-card-content v-if="!terminated">
            <flash-message v-if="errorMessages.length" :errors="errorMessages"></flash-message>
            <div>
              <p>退会を行うと、これまで取得した登記情報や全てのユーザー情報が利用できなくなりますがよろしいですか。</p>
              <p>毎月末日正午までに退会の手続きをすることにより、当月末日をもって退会となります。</p>
              <p>※ 退会後も月末まではサービスをご利用いただけます。</p>
            </div>
            <div class="md-layout md-alignment-center">
              <div class="md-layout-item md-size-100">
                <md-checkbox id="checkAccept" class="md-primary" v-model="form.checkAgree">
                  上記内容に同意して退会する
                </md-checkbox>
                <flash-message v-if="requiredCheckMessage" :errors="[requiredCheckMessage]"></flash-message>
              </div>
            </div>
          </md-card-content>
          <md-card-actions v-if="!terminated">
            <div class="md-layout md-alignment-center">
              <div class="md-layout-item md-size-10">
              </div>
              <div class="md-layout-item md-size-90">
                <md-button type="submit" class="md-raised md-accent"
                           :disabled="sending" @click="onSubmit">
                  退会の申請をする
                </md-button>
              </div>
            </div>
          </md-card-actions>

          <!--退会済みの時-->
          <md-card-content v-if="terminated">
            <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
            <div>
              <p>退会申請済です。当月末まではサービスをご利用いただけます。</p>
              <p>退会申請を取り消す場合はJON(jon-web_info@jon.co.jp)までご連絡ください。</p>
            </div>
          </md-card-content>
        </div>
      </div>
    </md-card>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
  import {apiClientWithUserToken as apiClient, apiList,} from '../../../modules/apiClient';
  import Common                                          from "../../../modules/common";
  import CommonMixin                                     from "../../../mixins/commonMixin";
  import FlashMessage                                    from "../../../components/FlashMessage";
  import Validation                                      from "../../../modules/validation";

  export default {
    name      : "UserDeactivate",
    components: {FlashMessage},
    mixins    : [CommonMixin],
    data      : () => ({
      form                : {
        checkAgree: false,
      },
      requiredCheckMessage: null,
      terminated          : null,
      sending             : false,
    }),
    mounted() {
      this.getTerminated();
    },
    methods   : {
      onSubmit() {
        this.requiredCheckMessage = null;
        if (this.form.checkAgree !== true) {
          this.requiredCheckMessage = Validation.errorMessage(Validation.rules.apply, 'apply');
          return;
        }
        this.terminate();
      },
      /**
       * 退会済みかを確認する。
       * 退会した当月は月末まで利用できるため複数回退会申請ができないように判断する用
       */
      getTerminated() {
        this.sending = true;
        apiClient.get(apiList.terminated)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.terminated = response.data.terminated;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
      },
      /**
       * 退会を申請する
       */
      terminate() {
        this.sending = true;
        apiClient.post(apiList.terminate)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.errorMessages = [Common.messages.terminate.terminateError];
              return;
            }
            this.showSnackBar   = true;
            this.successMessage = Common.messages.terminate.terminateSuccess;
          })
          .catch(error => {
            this.errorMessages = [Common.messages.terminate.terminateError];
          })
          .finally(() => {
            this.sending = false;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ml-20 {
    margin-left: 5%;
  }
</style>
